import { ChangeDetectorRef, Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LayoutAuthService } from 'src/app/components/layout/pages/layout-auth/layout-auth.service';
import { TermsType } from 'src/app/components/shared/api/ph-web/user/user.api_pb';
import { UserType } from 'src/app/components/shared/models/interface/userType.enum';
import { SharedAuthValidator } from 'src/app/components/shared/sharedConstants/auth.validators';
import { MuUserService } from 'src/app/components/shared/sharedProtos/user/mu-user.service';
import { FormControlValidatorService } from 'src/app/components/shared/sharedServices/form-control-validator.service';
import { MuToastService } from 'src/app/components/shared/sharedServices/mu-toast.service';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { MuException } from 'src/app/components/shared/types/exception.type';
import { FlagNotChanged, Flags } from 'src/app/components/shared/types/flags.type';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { environment } from 'src/environments/environment';
import { authConstants } from '../../auth.constants';
import { AccountDataActions } from './account-data.actionsenum.';
import { AccountDataFlags } from './authAccountData.flags';

@Component({
  selector: 'app-auth-account-data',
  templateUrl: './auth-account-data.component.html',
  styleUrls: ['./auth-account-data.component.sass'],
})
export class AuthAccountDataComponent extends MuComponent {
  formData: UntypedFormGroup;
  tmpUser: { [key: string]: any } = {};
  toastLife: number;
  country: number;
  flagList: Flags<AccountDataFlags> = new Flags<AccountDataFlags>();
  actionList: Actions<AccountDataActions, any> = new Actions<AccountDataActions, any>();
  accountDataActionsEnum = AccountDataActions;
  accountDataFlags = AccountDataFlags;
  authConstants = authConstants;
  termsLink: string;
  politicsLink: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private validator: FormControlValidatorService,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private muToastService: MuToastService,
    private layoutAuthService: LayoutAuthService<AccountDataFlags>,
    private muUserService: MuUserService
  ) {
    super();
    this.tmpUser = JSON.parse((localStorage.getItem('mu-auth-data') || '{}') + '');
  }

  muOnInit(): void {
    this.initData();
  }

  muOnDestroy(): void {
    const user: { [key: string]: any } = {};
    Object.keys(this.formData.controls).forEach(key => {
      user[key] = this.formData.get(key).value;
    });
    localStorage.setItem('mu-auth-data', JSON.stringify(user));
  }

  /**
   * init data
   */
  async initData(): Promise<void> {
    this.toastLife = environment.toastData.life;
    this.layoutAuthService.updateSettings({
      tab: 1,
      step: 1,
      title: 'titleData',
    });
    this.actionList.on(AccountDataActions.NEXT_STEP, (_, __) => {
      this.saveStep();
    });
    this.initForm();
    await this.getTermsLink();
  }

  /**
   * init form
   */
  initForm(): void {
    this.country = parseInt(JSON.parse(localStorage.getItem('mu-auth-phone')).country + '', 10);
    const sharedAuthValidator = new SharedAuthValidator(this.validator);

    this.formData = this.formBuilder.group({
      isInvalidForm: true,
      email: sharedAuthValidator.getEmail(),
      password: sharedAuthValidator.getPassword(),
      passwordChecker: sharedAuthValidator.getPasswordChecker(),
      accountType: ['1'],
      phone: localStorage.getItem('mu-auth-phone'),
      terms: [false, this.validator.isTrue()],
    });

    if (!this.tmpUser) {
      return environment.guardClause;
    }

    Object.keys(this.tmpUser).forEach(key => {
      this.formData.get(key)?.setValue(this.tmpUser[key]);
    });

    this.changeDetectorRef.detectChanges();
    this.formData.get('password').updateValueAndValidity();
  }

  /**
   * save first step
   */
  saveStep(): void {
    this.flagList.executeIfFalse(AccountDataFlags.CHECK_EMAIL, async (test: FlagNotChanged) => {
      await this.checkEmailAvailable();
      this.router.navigate(['/crear-cuenta/facturacion/' + (this.formData.get('accountType')?.value === '1' ? 'persona' : 'empresa')]);
    });
  }

  /**
   * validate if email exist
   */
  async checkEmailAvailable(): Promise<boolean> {
// eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        if (await this.muUserService.validateIfEmailExist(this.formData.get('email').value)) {
          this.formData.get('email').updateValueAndValidity();
          this.formData.get('email').setErrors({ invalid: true });
          throw new MuException({});
        }
        this.formData.get('email').setErrors({ invalid: false });
        this.formData.get('email').updateValueAndValidity();
        resolve(true);
      } catch (e: any | MuException) {
        this.muToastService.showSpecificToast({
          exception: e,
          key: 'toast-layout',
          severity: 'error',
          summary: 'toast.users.error.emailNotAvailable.title',
          detail: 'toast.users.error.emailNotAvailable.text',
          life: this.toastLife,
        });
        reject(false);
      }
    });
  }

  /**
   * get terms link
   */
  async getTermsLink(): Promise<void> {
    try {
      this.termsLink = await this.muUserService.getTermsOrPolitics(this.country, UserType.PERSON, TermsType.TERMS_AND_CONDITIONS);
      this.politicsLink = await this.muUserService.getTermsOrPolitics(this.country, UserType.PERSON, TermsType.DATA_PRIVACY_POLICY);
// eslint-disable-next-line no-empty
    } catch (e) {}
  }
}
